import { THEME_COLORS_ENUM } from '@/types/colors'

/**
 * Hero Card Color Configuration
 * Maps THEME_COLORS_ENUM to CSS variable names (global from _variables.scss).
 * Inline styles use var(--...) so values are resolved from :root.
 */
export const HERO_CARD_COLOR_CONFIG = {
	[THEME_COLORS_ENUM.PINK]: {
		cardBackground: 'var(--pink)',
		textColor: 'var(--text-color)',
		buttonBackground: 'var(--pink-light)',
		buttonHoverBackground: 'var(--pink-hover)',
		buttonHoverText: 'var(--white)'
	},
	[THEME_COLORS_ENUM.SAND]: {
		cardBackground: 'var(--sand)',
		textColor: 'var(--text-color)',
		buttonBackground: 'var(--sand-light)',
		buttonTextColor: 'var(--sand-contrast)',
		buttonHoverBackground: 'var(--sand-hover)',
		buttonHoverText: 'var(--text-color)'
	},
	[THEME_COLORS_ENUM.TIRQUOISE]: {
		cardBackground: 'var(--tirquoise)',
		textColor: 'var(--white)',
		buttonBackground: 'var(--tirquoise-light)',
		buttonHoverBackground: 'var(--tirquoise-hover)',
		buttonHoverText: 'var(--white)'
	},
	[THEME_COLORS_ENUM.BLUE]: {
		cardBackground: 'var(--blue)',
		textColor: 'var(--white)',
		buttonBackground: 'var(--blue-light)',
		buttonHoverBackground: 'var(--blue-hover)',
		buttonHoverText: 'var(--white)'
	},
	[THEME_COLORS_ENUM.FUCHSIA]: {
		cardBackground: 'var(--fuchsia)',
		textColor: 'var(--white)',
		buttonBackground: 'var(--fuchsia-light)',
		buttonHoverBackground: 'var(--fuchsia-hover)',
		buttonHoverText: 'var(--white)'
	},
	[THEME_COLORS_ENUM.PURPLE]: {
		cardBackground: 'var(--purple)',
		textColor: 'var(--text-color)',
		buttonBackground: 'var(--purple-light)',
		buttonHoverBackground: 'var(--purple-dark)',
		buttonHoverText: 'var(--white)'
	},
	[THEME_COLORS_ENUM.CYCLAMEN]: {
		cardBackground: 'var(--cyclamen)',
		textColor: 'var(--white)',
		buttonBackground: 'var(--cyclamen-light)',
		buttonHoverBackground: 'var(--cyclamen-hover)',
		buttonHoverText: 'var(--white)'
	},
	[THEME_COLORS_ENUM.WHITE]: {
		cardBackground: 'var(--white)',
		textColor: 'var(--white-text)',
		buttonBackground: 'var(--button-bg)',
		buttonHoverBackground: 'var(--text-color)',
		buttonHoverText: 'var(--white)'
	}
} as const
